import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useTranslation } from "react-i18next";

export type FilterType = "all" | "scheduled" | "unscheduled" | "paid" | "unpaid" | "recipient";

interface FilterSelectProps {
  currentFilter: FilterType;
  onFilterChange: (filter: FilterType) => void;
}

export const FilterSelect = ({ currentFilter, onFilterChange }: FilterSelectProps) => {
  const { t } = useTranslation();

  return (
    <Select value={currentFilter} onValueChange={onFilterChange}>
      <SelectTrigger className="w-[155px] text-[#34375B] bg-white hover:bg-[#5CC2BB] hover:text-[#34375B] hover:border-transparent hover:shadow-[4px_4px_0px_0px_#34375B] hover:-translate-x-[1px] hover:-translate-y-[1px] transition-all duration-200">
        <SelectValue placeholder="Filter invoices" />
      </SelectTrigger>
      <SelectContent className="bg-white border border-gray-300 p-2 rounded-md">
        <SelectItem value="all">{t("status_filters.all")}</SelectItem>
        <SelectItem value="scheduled">{t("status_filters.scheduled")}</SelectItem>
        <SelectItem value="unscheduled">{t("status_filters.unscheduled")}</SelectItem>
        <SelectItem value="paid">{t("status_filters.paid")}</SelectItem>
        <SelectItem value="unpaid">{t("status_filters.unpaid")}</SelectItem>
        <SelectItem value="recipient">{t("status_filters.recipient")}</SelectItem>
      </SelectContent>
    </Select>
  );
};